import { defineStore } from 'pinia'

import state from './state'
import getters from './getters'
import actions from './actions'

const useFormsStore = defineStore('forms', {
  state,
  getters,
  actions
})

export default useFormsStore
